import React, { forwardRef, useEffect, useState } from 'react'
import { Input, Cascader } from '@ow/comps'
import { useDitto } from '@ow/ditto-core'

export default forwardRef(({ opts = {}, value, style, onChange }, ref) => {
  const { fieldIsDisabled, remote } = opts
  const { onFetchRemoteData } = useDitto()
  const [options, setOptions] = useState([])

  useEffect(() => {
    if (onFetchRemoteData && remote && remote.api) {
      // 如果配置了api,走extend请求定制接口
      if (remote && remote.api) {
        const extend = onFetchRemoteData('extend')

        extend[remote.api](remote.url, remote.opts).then((res) => {
          if (res) {
            setOptions(
              (res || []).map((option) => {
                return { ...option, label: option.title }
              })
            )
          }
        })
      }
    }
  }, [])

  if (opts.render === 'cascader') {
    return (
      <Cascader
        tree={options}
        inputStyle={{
          height: '34px',
          width: '100%',
          ...style,
        }}
        placeholder={opts.hint || `请选择${opts.title}`}
        inputClassName="right-input"
        fieldNames={{
          label: 'title',
          value: 'title',
          children: 'children',
        }}
        allowClear={false}
        onChange={(selectedKeys) => {
          onChange(selectedKeys)
        }}
        value={value || undefined}
        notFoundContent="暂无数据"
      />
    )
  }

  return (
    <Input
      ref={ref}
      {...opts}
      style={{
        height: '100%',
        width: '132px',
        ...style,
      }}
      disabled={fieldIsDisabled}
      className="right-input"
      placeholder={opts.hint || `请输入${opts.title}`}
      onChange={(e) => {
        onChange(e.target.value)
      }}
      value={value}
    />
  )
})
